import { render, staticRenderFns } from "./VoteOptionImg.vue?vue&type=template&id=31848aca&"
import script from "./VoteOptionImg.vue?vue&type=script&lang=js&"
export * from "./VoteOptionImg.vue?vue&type=script&lang=js&"
import style0 from "./VoteOptionImg.vue?vue&type=style&index=0&id=31848aca&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports